export default __webpack_public_path__ + "static/media/destination.686a4f97.svg";